export default __webpack_public_path__ + "static/WDRMODE_1_WDR_STRENGTH_5(2)-736706b50d50f7b6c8e1f5564b591872.avif";